import script from "./ComunicacaoFalta.vue?vue&type=script&setup=true&lang=js"
export * from "./ComunicacaoFalta.vue?vue&type=script&setup=true&lang=js"

import "./ComunicacaoFalta.vue?vue&type=style&index=0&id=d5402648&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5402648"]])

export default __exports__